<template>
  <div class="contact-form container">
    <form v-if="form">
      <div class="row contact-form-header">
        <div class="col-12">
          <h5 class="modal-title">Potrzebujesz pomocy?</h5>
          <p>Skorzystaj z naszego formularza kontaktowego,</p>
          <p>a my skontaktujemy się z Tobą tak szybko, jak to tylko możliwe.</p>
        </div>
      </div>
      <div class="row contact-form-body">
        <div class="col-12">
          <h3>KONTAKT</h3>
        </div>

        <div class="col-12 col-md-6">
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="company_name">Nazwa firmy</label>
                <input
                  id="company_name"
                  name="company_name"
                  class="form-control"
                  type="text"
                  required
                  v-model="form.company_name.value"
                  @blur="validateField($event, form.company_name)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.company_name.errors.required"
                >Nazwa firmy nie może być pusta</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-6">
              <div class="form-group">
                <label for="name">Imię</label>
                <input
                  id="name"
                  name="name"
                  class="form-control"
                  type="text"
                  required
                  v-model="form.name.value"
                  @blur="validateField($event, form.name)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.name.errors.required"
                >Imię nie może być puste</span>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="last_name">Nazwisko</label>
                <input
                  id="last_name"
                  name="last_name"
                  class="form-control"
                  type="text"
                  required
                  v-model="form.last_name.value"
                  @blur="validateField($event, form.last_name)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.last_name.errors.required"
                >Nazwisko nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-6">
              <div class="form-group">
                <label for="email">E-mail</label>
                <input
                  id="email"
                  name="email"
                  class="form-control"
                  type="email"
                  required
                  v-model="form.email.value"
                  @blur="validateField($event, form.email)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.email.errors.required"
                >Email nie może być pusty</span>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="phone">Telefon</label>
                <input
                  id="phone"
                  name="phone"
                  class="form-control"
                  type="text"
                  required
                  v-model="form.phone.value"
                  @blur="validateField($event, form.phone)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.phone.errors.required"
                >Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="street">Ulica i numer</label>
                <input
                  id="street"
                  name="street"
                  class="form-control"
                  type="text"
                  required
                  v-model="form.street.value"
                  @blur="validateField($event, form.street)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.street.errors.required"
                >Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-6">
              <div class="form-group">
                <label for="postcode">Kod pocztowy</label>
                <input
                  id="postcode"
                  name="postcode"
                  class="form-control"
                  type="test"
                  required
                  v-model="form.postcode.value"
                  @blur="validateField($event, form.postcode)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.postcode.errors.required"
                >Pole nie może być puste</span>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="city">Miejscowość</label>
                <input
                  id="city"
                  name="city"
                  class="form-control"
                  type="text"
                  required
                  v-model="form.city.value"
                  @blur="validateField($event, form.city)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.city.errors.required"
                >Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="country">Kraj</label>
                <input
                  id="country"
                  name="country"
                  class="form-control"
                  type="text"
                  required
                  v-model="form.country.value"
                  @blur="validateField($event, form.country)"
                >
                <span
                  class="invalid-feedback"
                  v-if="form.country.errors.required"
                >Pole nie może być puste</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="subject">Proszę wybrać temat</label>
                <select
                  v-model="form.subject.value"
                  id="subject"
                  name="subject"
                  class="form-control"
                >
                  <option v-for="subject in subjects" :value="subject">{{ subject }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="message">Wiadomość</label>
                <textarea
                  id="message"
                  class="form-control"
                  rows="6"
                  required
                  v-model="form.message.value"
                  @blur="validateField($event, form.message)"
                ></textarea>
                <span
                  class="invalid-feedback"
                  v-if="form.message.errors.required"
                >Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12 contact-prefer">
              <label>Preferowana forma kontaktu</label>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="pEmail"
                  v-model="form.prefer_email.value"
                >
                <label class="form-check-label" for="pEmail">E-mail</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="pPhone"
                  v-model="form.prefer_phone.value"
                >
                <label class="form-check-label" for="pPhone">Telefon</label>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12 contact-prefer">
              <div class="contact_button">
                <button
                  class="btn btn-primary"
                  :disabled="!submittable"
                  @click="submit"
                  right
                >WYŚLIJ WIADOMOŚĆ</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Form from '../../form/src/Form';

export default {
  components: {},
  data() {
    return {
      form: Form.build({
        company_name: "",
        name: "",
        last_name: "",
        email: "",
        phone: "",
        street: "",
        postcode: "",
        city: "",
        country: "",
        subject: "Rejestracja nowego klienta",
        message: "",
        prefer_email: true,
        prefer_phone: true
      }),
      subjects: ["Rejestracja nowego klienta", "Jak kupować?", "Inny temat"],
      submitted: false,
      progress: false
    };
  },
  computed: {
    submittable() {
      return !this.progress && !this.submitted;
    }
  },
  methods: {
    ...Form.methods(),
    async submit(evt) {
      let data = this.validateForm(evt, this.form);
      if (data) {
        this.progress = true;
        this.submitted = true;
        await this.$store.dispatch("company/sendMessage", data);
        // this.$store.dispatch(
        //   "addSuccessNotification",
        //   "Wiadmość została wysłana"
        // );
        this.$store.dispatch("addNotification", {
          key: "contactForm",
          message: ""
        });
        this.progress = false;
        this.submitted = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/company/src/ContactForm.vue